import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { Wrapper, InnerWrapper } from './styles.js';
import { Flex } from '../Flex/Flex.js';

function Collapse(_a) {
    var { children, open, timeout = 500, unmountOnExit = true } = _a, rest = __rest(_a, ["children", "open", "timeout", "unmountOnExit"]);
    const innerWrapperRef = useRef({ clientHeight: 0 });
    return (React.createElement(Transition, Object.assign({ in: open, timeout: timeout, unmountOnExit: unmountOnExit }, rest), (state, innerProps) => {
        var _a;
        return (React.createElement(Wrapper, Object.assign({ state: state, maxHeight: (_a = innerWrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight, timeout: timeout }, innerProps),
            React.createElement(Flex, null,
                React.createElement(InnerWrapper, { ref: innerWrapperRef }, children))));
    }));
}

export { Collapse as default };
